"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slugBlocksToPrompterText = void 0;
const __1 = require("../..");
const PROMPTER_ELEMENTS = [
    'dialogue',
    'character',
    'parenthetical',
];
const EOL = '\r\n';
// takes a single node of type dialogue, bracket or parenthetical
// and returns a string
const blockToPrompterText = (block, isFirstBlock) => {
    if (!PROMPTER_ELEMENTS.includes(block.elementType)) {
        return '';
    }
    const isCharacterBlock = block.elementType === 'character';
    const parts = [];
    block.pmNode.descendants((child) => {
        if (child.type.name === __1.NodeTypeMap.TEXT) {
            if (child.textContent.length > 0) {
                parts.push(child.textContent);
            }
        }
        else if (child.type.name === __1.NodeTypeMap.HARD_BREAK) {
            parts.push(EOL);
        }
    });
    // if this is a non-empty character block which is not the first,
    // prepend a line break
    if (isCharacterBlock && !isFirstBlock && parts.length > 0) {
        parts.unshift(EOL);
    }
    // if the content is empty preserve the spacing by adding a carriage return
    // if (parts.length === 0) {
    parts.push(EOL);
    // }
    const resultStr = parts.join('');
    return isCharacterBlock ? resultStr.toUpperCase() : resultStr;
};
const slugBlocksToPrompterText = (blocks) => {
    const parts = blocks.map((block, index) => {
        return blockToPrompterText(block, index === 0);
    });
    return parts.join('');
};
exports.slugBlocksToPrompterText = slugBlocksToPrompterText;
